import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-header-result-card',
  templateUrl: './header-result-card.component.html',
  styleUrls: ['./header-result-card.component.scss']
})
export class HeaderResultCardComponent implements OnInit {

  @Input()
  title: string;

  constructor() {
  }

  ngOnInit() {
  }

}
